import {useTranslation} from "react-i18next";
import {useState} from "react";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Collapse from "react-bootstrap/Collapse";
import SearchSelect from "components/selects/SearchSelect";
import WasteTypesOptionsArray from "site-apps/assets/WasteTypesOptionsArray";

const IslandFilters = ({filters, show}) => {
    const {t: _Tt} = useTranslation("tables");
    const {t: _Tc} = useTranslation("choices");
    const [selectedWasteType, setSelectedWasteType] = useState([]);

    const onChangeWasteType = (selectedOptions) => {
        if (!selectedOptions || selectedOptions.length === 0) {
            setSelectedWasteType([]);
            delete filters.current.chosen.waste_type;
        } else {
            const vals = selectedOptions.map((o) => o.value);
            setSelectedWasteType(selectedOptions);
            filters.current.chosen.waste_type = vals;
        }
    };

    const clearFilters = () => {
        setSelectedWasteType([]);
        delete filters.current.chosen.waste_type;
    };

    const wasteTypeOptions = (WasteTypesOptionsArray || []).map((type) => ({
        value: type,
        label: _Tc(`wastes.${type}`, {defaultValue: type}),
    }));

    return (
        <Collapse in={show}>
            <div id="filter-collapse" className="p-3">
                <div className="row mb-1 d-flex align-items-center">
                    <div className="col pt-3 mt-2" style={{maxWidth: "80px"}}>
                        <Button
                            variant="link"
                            type="button"
                            onClick={clearFilters}
                            title={_Tt("common.clearFilters")}>
                            <FontAwesomeIcon icon="filter-circle-xmark" />{" "}
                        </Button>
                    </div>
                    <div className="col-3">
                        <label style={{fontWeight: "bold"}}>
                            {_Tt("containers.waste_type")}
                        </label>
                        <SearchSelect
                            options={[
                                {value: "", label: _Tc("devices.all")},
                                ...wasteTypeOptions,
                            ]}
                            placeholder={_Tc("devices.all")}
                            value={selectedWasteType}
                            onChange={onChangeWasteType}
                            isClearable
                            isMulti={true}
                        />
                    </div>
                    <div className="col pt-3 mt-2">
                        <Button
                            variant="primary"
                            onClick={filters.current.filter}
                            title={_Tt("common.applyFilters")}>
                            <FontAwesomeIcon icon="magnifying-glass" />{" "}
                        </Button>
                    </div>
                </div>
            </div>
        </Collapse>
    );
};

export default IslandFilters;
